import Vue           from 'vue';
import Cookie        from 'js-cookie';
import JWTDecode     from 'jwt-decode';
import Axios         from 'axios';
import Configuration from './configuration.js';
import Store         from './store.js';


const User =
{
    UserEnum: {
        NONE:       null,
        PATIENT:    1,
        PROVIDER:   2,
        properties: [
            {
                text:        "Select One",
                value:       null,
                welcomePath: ""
            },
            {
                text:        "Patient",
                value:       1,
                welcomePath: "/patient/welcome"
            },
            {
                text:        "Provider",
                value:       2,
                welcomePath: "/provider/welcome"
            }
        ]
    },
    getLongUsername:
        function ()
        {
            var userInfo = Cookie.getJSON( 'meta-user' );
            var name       = '';

            if( userInfo != null && userInfo.tokens != null && userInfo.tokens.idToken != null )
            {
                var idToken = JWTDecode( userInfo.tokens.idToken );
                if( idToken != null )
                {
                    if( userInfo.type.toLowerCase() === "provider" )
                        name = idToken.given_name + ' ' + idToken.family_name;
                    else if( userInfo.type.toLowerCase() === "patient" )
                        name = idToken.username;
                }
            }

            return name;
        },
    getUsername:
        function ()
        {
            var userInfo = Cookie.getJSON( 'meta-user' );
            var name     = '';

            if( userInfo != null && userInfo.tokens != null && userInfo.tokens.idToken != null )
            {
                var idToken    = JWTDecode( userInfo.tokens.idToken );
                if( idToken != null )
                {
                    if( userInfo.type.toLowerCase() === "provider" )
                        name = idToken.email;
                    else if( userInfo.type.toLowerCase() === "patient" )
                        name = idToken.username;
                }
            }

            return name;
        },
    isAuthenticated:
        function ()
        {
            var userInfo = Cookie.getJSON( 'meta-user' );
            if( userInfo == null || userInfo.tokens == null || userInfo.tokens.accessToken == null )
                return false;

            var access = JWTDecode( userInfo.tokens.accessToken );
            var now    = new Date();
            if( now.getMilliseconds() >= access.exp )
                return false;

            return true;
        },
    getUserType:
        function ()
        {
            var userInfo = Cookie.getJSON( 'meta-user' );
            if( userInfo == null )
                return "";

            return userInfo.type;
        },
    signUp:
        function ( credentials, parameters, successCallback, failureCallback )
        {
            var url = Configuration.MetaposeAPI.BaseURL 
                    + Configuration.MetaposeAPI.Version
                    + '/' + this.UserEnum.properties[ parameters.userType ].text.toLowerCase()
                    + '/signup';

            var requestParams = {};
            if( parameters.userType === this.UserEnum.PATIENT )
            {
                requestParams = {
                        attributes:         parameters.attributes,
                        recaptchaResponse:  parameters.recaptchaResponse
                    };
            }
            else if( parameters.userType === this.UserEnum.PROVIDER )
            {
                requestParams = {
                        username:   credentials.username,
                        password:   credentials.password,
                        attributes: parameters.attributes
                    };
            }

            try
            {
                Axios.post(
                    url,
                    requestParams,
                    {
                        withCredentials: true
                    }
                )
                .then(
                    function ( response )
                    {
                        var result = { username: response.data.username, password: response.data.password };

                        if( successCallback != null )
                            successCallback( result );
                    }
                )
                .catch(
                    function ( error )
                    {
                        if( failureCallback != null )
                            failureCallback( error );
                    }
                );
            }
            catch( error )
            {
                alert( 'User Signin Exception: ' + error );
            }
    },
    signIn:
        function ( credentials, parameters, successCallback, failureCallback )
        {
            var _this = this;
            var url   = Configuration.MetaposeAPI.BaseURL 
                      + Configuration.MetaposeAPI.Version
                      + '/' + this.UserEnum.properties[ parameters.userType ].text.toLowerCase()
                      + '/signin';
            Axios.post(
                url,
                {
                    recaptchaResponse:  parameters.recaptchaResponse
                },
                {
                    auth:               { username: credentials.username, password: credentials.password },
                    withCredentials:    true
                }
            )
            .then(
                function ( response )
                {
                    var tokens   = response.data.tokens;
                    var userType = _this.UserEnum.properties[ parameters.userType ];

                    Cookie.set( 'meta-user', { tokens: tokens, type: userType.text } );

                    Store.state.user.isAuthenticated = true;
                    Store.state.user.longUsername    = _this.getLongUsername();
                    Store.state.user.username        = _this.getUsername();

                    if( successCallback != null )
                        successCallback();
                }
            )
            .catch(
                function ( error )
                {
                    if( failureCallback != null )
                        failureCallback( error );
                }
            );

        },
    signOut:
        function ( successCallback, failureCallback )
        {
            Cookie.remove( 'meta-user' );
            Store.state.user.isAuthenticated = false;
            Store.state.user.longUsername    = null;
            Store.state.user.username        = null;

            if( successCallback != null )
                successCallback();
        },
    confirm:
        function ( username, confirmationCode, type, successCallback, failureCallback )
        {
            if( type != this.UserEnum.PROVIDER )
            {
                failureCallback( 'Invalid user type.' );
                return;
            }

            var url = Configuration.MetaposeAPI.BaseURL 
                    + Configuration.MetaposeAPI.Version
                    + '/' + this.UserEnum.properties[ type ].text.toLowerCase()
                    + '/confirm';

            Axios.post(
                    url,
                    {
                        username:           username,
                        confirmation_code:  confirmationCode
                    },
                    {
                    }
                )
                .then(
                    function ( response )
                    {
                        if( successCallback != null )
                            successCallback();
                    }
                )
                .catch(
                    function ( error )
                    {
                        if( failureCallback != null )
                            failureCallback( error );
                    }
                );
        },
    forgotPassword:
        function ( username, type, successCallback, failureCallback )
        {
            if( type != this.UserEnum.PROVIDER )
            {
                failureCallback( 'Invalid user type.' );
                return;
            }

            var url = Configuration.MetaposeAPI.BaseURL 
                    + Configuration.MetaposeAPI.Version
                    + '/' + this.UserEnum.properties[ type ].text.toLowerCase()
                    + '/forgotpassword';

            Axios.post(
                    url,
                    {
                        username: username
                    },
                    {
                    }
                )
                .then(
                    function ( response )
                    {
                        if( successCallback != null )
                            successCallback();
                    }
                )
                .catch(
                    function ( error )
                    {
                        if( failureCallback != null )
                            failureCallback( error );
                    }
                );

        },
    resendVerificationCode:
        function ( username, type, successCallback, failureCallback )
        {
            if( type != this.UserEnum.PROVIDER )
            {
                failureCallback( 'Invalid user type.' );
                return;
            }

            var url = Configuration.MetaposeAPI.BaseURL
                    + Configuration.MetaposeAPI.Version
                    + '/' + this.UserEnum.properties[ type ].text.toLowerCase()
                    + '/resendconfirmation';

            Axios.post(
                    url,
                    {
                        username: username
                    }
                )
                .then( 
                    function( response )
                    {
                        if( successCallback != null )
                            successCallback();
                    }
                 )
                .catch(
                    function ( error )
                    {
                        if( failureCallback != null )
                            failureCallback( error );
                    }
                );
        },
    confirmPassword:
        function ( username, password, verficationCode, type, successCallback, failureCallback )
        {
            if( type != this.UserEnum.PROVIDER )
            {
                failureCallback( 'Invalid user type.' );
                return;
            }

            var url = Configuration.MetaposeAPI.BaseURL
                    + Configuration.MetaposeAPI.Version
                    + '/' + this.UserEnum.properties[ type ].text.toLowerCase()
                    + '/confirmpassword';

            Axios.post(
                    url,
                    {
                        username:           username,
                        password:           password,
                        verification_code:  verficationCode
                    },
                    {
                    }
                )
                .then(
                    function ( response )
                    {
                        if( successCallback != null )
                            successCallback();
                    }
                )
                .catch(
                    function ( error )
                    {
                        if( failureCallback != null )
                            failureCallback( error );
                    }
                );
        },
    changePassword:
        function ( type, oldPassword, newPassword, successCallback, failureCallback )
        {
            if( type != this.UserEnum.PROVIDER )
            {
                failureCallback( 'Invalid user type.' );
                return;
            }

            var url = Configuration.MetaposeAPI.BaseURL
                    + Configuration.MetaposeAPI.Version
                    + '/' + this.UserEnum.properties[ type ].text.toLowerCase()
                    + '/changepassword';

            Axios.post(
                url,
                {
                    old_password:   oldPassword,
                    new_password:   newPassword
                },
                {
                }
            )
            .then(
                function ( response )
                {
                    if( successCallback != null )
                        successCallback();
                }
            )
            .catch(
                function ( error )
                {
                    if( failureCallback != null )
                        failureCallback( error );
                }
            );
        }
}


Object.freeze( User );
export default User;


// WEBPACK FOOTER //
// ./src/user.js